
export default {

    stockists(state){
        return state.stockists
    },

    stockist(state){
        return state.stockist
    },

    rebateEarnings(state){
        return state.rebateEarnings
    },

    stockistsStats(state){
        return state.stockistsStats
    },

    stockistsOrders(state){
        return state.sotckistsOrders
    },

    stockistsAction(state){
        return state.stockistsAction
    },

    stockistsState(state){
        return state.stockistsState
    },

    stockistsCurrentPage(state){
        return state.stockistsCurrentPage
    },

    stockistsLastPage(state){
        return state.stockistsLastPage
    },

    stockistsPerPage(state){
        return state.stockistsPerPage
    },

    stockistsTotalPages(state){
        return state.stockistsTotalPages
    },

    stockistsOrdersAction(state){
        return state.stockistsOrdersAction
    },

    stockistsOrdersState(state){
        return state.stockistsOrdersState
    },
    stockistsOrdersCurrentPage(state){
        return state.stockistsOrdersCurrentPage
    },
    stockistsOrdersLastPage(state){
        return state.stockistsOrdersLastPage
    },
    stockistsOrdersPerPage(state){
        return state.stockistsOrdersPerPage
    },
    stockistsOrdersTotalPages(state){
        return state.stockistsOrdersTotalPages
    },

    stockistUpgrades(state){
        return state.stockistUpgrades
    },

    stockistUpgradesAction(state){
        return state.stockistUpgradesAction
    },

    stockistUpgradesState(state){
        return state.stockistUpgradesState
    },
    stockistUpgradesCurrentPage(state){
        return state.stockistUpgradesCurrentPage
    },
    stockistUpgradesLastPage(state){
        return state.stockistUpgradesLastPage
    },
    stockistUpgradesPerPage(state){
        return state.stockistUpgradesPerPage
    },
    stockistUpgradesTotalPages(state){
        return state.stockistUpgradesTotalPages
    },
}